<template>
  <LsModal
    :title="title"
    track-id="leads_hired_details_modal"
    class="leads-hired-details-modal--container"
  >
    <template #body>
      <form novalidate @submit.prevent="submitHiredDetails">
        <LsInputMasked
          v-model="cost"
          track-id="leads_hired_details_modal-cost"
          label="Project Cost"
          mask="currency"
          name="cost"
          :validation="{ required: true, ['ls-currency']: { min: 1, max: 100000 } }"
        />
        <LsDatepicker
          v-model="expectedCompletionDate"
          track-id="leads_hired_details_modal-expected_completion_date"
          label="Expected Completion Date"
          :min-date="minDate"
          :max-date="maxDate"
          :validation="{ required: true }"
          name="expected-completion-date"
        />
        <LsSelect
          v-model="reason"
          track-id="leads_hired_details_modal-reason"
          test-id="leads-hired-details-modal_reason"
          :label="reasonLabel"
          name="reason"
          :options="reasonOptions"
          :validation="{ required: true }"
        />
        <div class="leads-hired-details-modal--submit-wrapper">
          <LsButton
            class="leads-hired-details-modal--submit"
            text="Submit"
            track-id="leads_hired_details_modal-submit"
            type="submit"
            :loading="customerLeads.loadingStatus.isUpdating"
          />
        </div>
      </form>
    </template>
  </LsModal>
</template>

<script>
import moment from 'moment';
import { LsButton, LsSelect, LsInputMasked, LsDatepicker, LsModal } from '@/components/common';
import { lsFilters } from 'ls-vue-common';
import VueTypes from 'vue-types';
import { mapActions, mapState } from 'vuex';
import { CUSTOMER_LEADS__UPDATE_HIRED_DETAILS } from '@/store/types';
import { REASON_OPTIONS } from '@/constants/customerLeads';

export default {
  name: 'LeadsHiredDetailsModal',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsButton,
    LsSelect,
    LsInputMasked,
    LsDatepicker,
    LsModal,
  },
  props: {
    customerLeadContact: VueTypes.shape({
      id: VueTypes.number,
      status: VueTypes.string,
      contractor: VueTypes.shape({
        user: VueTypes.shape({
          first_name: VueTypes.string.isRequired,
          last_name: VueTypes.string,
        }).isRequired.loose,
        name: VueTypes.string.isRequired,
      }).isRequired.loose,
    }),
    customerLeadId: VueTypes.number.isRequired,
    propertyId: VueTypes.number.isRequired,
    serviceName: VueTypes.string.isRequired,
    createdAt: VueTypes.string.isRequired,
  },
  data() {
    return {
      reason: undefined,
      cost: undefined,
      expectedCompletionDate: moment(moment().format('YYYY-MM-DD')).toDate(),
    };
  },
  computed: {
    ...mapState(['customerLeads']),
    minDate() {
      return moment.utc(this.createdAt, 'YYYY-MM-DD').toDate();
    },
    maxDate() {
      return moment
        .utc()
        .add(90, 'days')
        .toDate();
    },
    reasonOptions() {
      return REASON_OPTIONS;
    },
    reasonLabel() {
      return `Why did you hire ${lsFilters.fullName({
        user: this.customerLeadContact.contractor.user,
      })}?`;
    },
    title() {
      return `Service Details: ${this.serviceName}`;
    },
  },
  methods: {
    ...mapActions([CUSTOMER_LEADS__UPDATE_HIRED_DETAILS]),
    async submitHiredDetails() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }
      const {
        propertyId,
        customerLeadId,
        customerLeadContact,
        reason,
        cost,
        expectedCompletionDate,
        onSuccess,
      } = this;
      this[CUSTOMER_LEADS__UPDATE_HIRED_DETAILS]({
        customer_lead_id: customerLeadId,
        property_id: propertyId,
        contact_id: customerLeadContact.id,
        hiredDetails: {
          reason,
          cost,
          expected_completion_date: moment.utc(expectedCompletionDate).format('YYYY-MM-DD'),
        },
        onSuccess,
      });
    },
    onSuccess() {
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss">
.leads-hired-details-modal--container {
  padding: 60px;
  .modal-body {
    padding: 0;
  }
  .leads-hired-details-modal--submit-wrapper {
    display: flex;
  }
  .leads-hired-details-modal--submit {
    margin-top: 30px;
    margin-left: auto;
  }
  .modal-header {
    margin-bottom: 30px;
  }
}
</style>
